module.exports = __webpack_public_path__ + "static/media/home_header5.4fdc6b50.jpg";